import T from "./JFormContainer.vue";

var install = function install(Vue) {
  Vue.component('JFormContainer', T);
};

export default {
  install: install
};